import { OurNode } from "./our-node";
import { getInitialStructureNodeset } from "../dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "../dependency-injection-container/get-machine-structure-nodeset";

export class TransferredComparer {
  initialFlatMap: Map<string, OurNode>;
  machineFlatMap: Map<string, OurNode>;

  constructor(
    initalFlatMap: Map<
      string,
      OurNode
    > = getInitialStructureNodeset().getFlatMap(),
    machineFlatMap: Map<
      string,
      OurNode
    > = getMachineStructureNodeset().getFlatMap(),
  ) {
    this.initialFlatMap = initalFlatMap;
    this.machineFlatMap = machineFlatMap;
  }

  setFoundNodeToTransferred() {
    if (!this.initialFlatMap) {
      return;
    }

    for (const id of Array.from(this.initialFlatMap.keys())) {
      const node = this.initialFlatMap.get(id);
      node.transfered = this.machineFlatMap.has(id);
    }
  }
}
